const POPOVER_SELECTOR = '.v-tour__popover, #v-tour-default-popover';
const OVERLAY_SELECTOR = '.v-tour__overlay';
const HIGHLIGHT_SELECTOR = '.v-tour__highlighted-target';

/**
 * Defensively wipes any tour DOM left over from a previous route. The library
 * keeps a singleton controller, so route changes can strand popovers, overlays,
 * and inline styles on `document.body`. Safe to call on any navigation.
 */
export function forceCleanupTourDom(): void {
  document.querySelectorAll(POPOVER_SELECTOR).forEach((el) => el.remove());
  document.querySelectorAll(OVERLAY_SELECTOR).forEach((el) => el.remove());
  document.querySelectorAll(HIGHLIGHT_SELECTOR).forEach((node) => {
    const el = node as HTMLElement;
    el.classList.remove('v-tour__highlighted-target');
    el.style.removeProperty('z-index');
    el.style.removeProperty('box-shadow');
    if (el.style.position === 'relative') {
      el.style.removeProperty('position');
    }
  });
}
